import {actionBookingTransform} from "./ActionBookingTransform";
import {actionCallTransferTransform} from "./ActionCallTransferTransform";
import {actionCustomEvalTransform} from "./ActionCustomEvalTransform";
import {actionCustomTransform} from "./ActionCustomTransform";
import {actionInformationExtractorTransform} from "./ActionInformationExtractorTransform";
import {actionIVRTransform} from "./ActionIVRTransform";
import {actionSmsTransform} from "./ActionSendSmsTransform";
import {customActionTemplateTransform} from "./CustomActionTemplateTransform";
import {localesTransform} from "./LocalesTransform";
import {providersTransform} from "./ProvidersTransform";
import {timezonesTransform} from "./TimezonesTransform";

import {ActionTypeModel} from "@/api/models";
import {actionNodeTransform} from "./ActionNodeTransform";

export const actionTransform = {
  [ActionTypeModel.BOOKING]: actionBookingTransform,
  [ActionTypeModel.TRANSFER]: actionCallTransferTransform,
  [ActionTypeModel.CUSTOM]: actionCustomTransform,
  [ActionTypeModel.INFO]: actionInformationExtractorTransform,
  [ActionTypeModel.SMS]: actionSmsTransform,
  [ActionTypeModel.IVR]: actionIVRTransform,
  [ActionTypeModel.EVAL]: actionCustomEvalTransform,
} as const;

export {actionBookingTransform};
export {actionCallTransferTransform};
export {actionCustomTransform};
export {actionInformationExtractorTransform};
export {actionSmsTransform};
export {timezonesTransform};
export {localesTransform};
export {providersTransform};
export {customActionTemplateTransform};
export {actionCustomEvalTransform};
export {actionNodeTransform};
